import { useCallback, useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/contexts/AuthContext";

export interface ObraFinalizadaSinDocs {
  id: string;
  nombre: string;
  cliente_nombre: string | null;
  fecha_fin_real: string | null;
  entrega_pospuesta: boolean;
}

export function useObrasFinalizadasSinDocs() {
  const { perfil } = useAuth();
  const [obras, setObras] = useState<ObraFinalizadaSinDocs[]>([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    if (!perfil?.empresa_id) return;
    setLoading(true);
    const { data: finalizadas } = await (supabase as any)
      .from("obras")
      .select("id,nombre,fecha_fin_real,entrega_pospuesta,cliente:clientes(nombre)")
      .eq("empresa_id", perfil.empresa_id)
      .eq("estado", "finalizada");

    const list = (finalizadas ?? []) as any[];
    if (list.length === 0) {
      setObras([]);
      setLoading(false);
      return;
    }
    const ids = list.map((o) => o.id);
    const { data: docs } = await (supabase as any)
      .from("obra_entrega_documentos")
      .select("obra_id")
      .in("obra_id", ids);
    const conDocs = new Set<string>((docs ?? []).map((d: any) => d.obra_id));
    setObras(
      list
        .filter((o) => !conDocs.has(o.id))
        .map((o) => ({
          id: o.id,
          nombre: o.nombre,
          fecha_fin_real: o.fecha_fin_real,
          entrega_pospuesta: o.entrega_pospuesta,
          cliente_nombre: o.cliente?.nombre ?? null,
        })),
    );
    setLoading(false);
  }, [perfil?.empresa_id]);

  useEffect(() => {
    load();
  }, [load]);

  return { obras, loading, reload: load };
}
